/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-05-24 17:40:28
 * @LastEditors: linxi
 * @LastEditTime: 2021-09-08 10:32:21
 */
import React, { useContext } from "react";
import { Button, Col, Form, Input, Row, Select } from "antd";
import {
  CaretDownFilled,
  PlusOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import { AccountStationParams } from "../../services/AccountStation";
import { ThemeContext } from "../../theme/theme";

export const AccountQuery = (props: {
  onValueChange: (queries: AccountStationParams) => void;
  save: () => void;
}) => {
  const [form] = Form.useForm();

  const theme = useContext(ThemeContext);

  return (
    <Form
      form={form}
      autoComplete="off"
      name="control-hooks"
      onFieldsChange={(_, fs) => {
        props.onValueChange(form.getFieldsValue());
      }}
    >
      <Row
        gutter={10}
        wrap={false}
        style={{
          height: "40px",
          paddingRight: "10px",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <Row>
          <Col style={{ marginRight: "10px" }}>
            <Form.Item name="userName">
              <Input
                placeholder="用户名/姓名"
                allowClear
                prefix={<SearchOutlined />}
              />
            </Form.Item>
          </Col>
          <Col>
            <Form.Item name="status" noStyle>
              <Select
                showSearch
                suffixIcon={<CaretDownFilled style={{ color: theme.tc3 }} />}
                style={{ width: "200px" }}
                allowClear
                onChange={form.submit}
                placeholder="启用状态"
              >
                <Select.Option value={0}>启用状态-停用</Select.Option>
                <Select.Option value={1}>启用状态-启用</Select.Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Button
            type="primary"
            onClick={() => {
              props.onValueChange(form.getFieldsValue());
            }}
            style={{ marginRight: "10px" }}
          >
            查询
          </Button>
          <Button
            style={{ marginRight: "15px" }}
            type="primary"
            ghost
            icon={<PlusOutlined />}
            onClick={() => {
              props.save();
            }}
          >
            新增
          </Button>
        </Row>
      </Row>
    </Form>
  );
};
